import { render, staticRenderFns } from "./HtFawuContractEditForm.vue?vue&type=template&id=64d15b3c&scoped=true&"
import script from "./HtFawuContractEditForm.vue?vue&type=script&lang=js&"
export * from "./HtFawuContractEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d15b3c",
  null
  
)

export default component.exports